import { FadeUp } from "@/components/Reveal";

const PHOTOS = [
  {
    src: "/images/gallery/ceremony-nest.jpg",
    caption: "The nest, prepared in your living room",
    alt: "A ceremony nest of blankets and cushions laid out on a living-room floor",
    description:
      "Before you arrive, I gather cushions, warm blankets, soft light and simmering pots — turning your own living room into a sanctuary where you can be laid down and tended.",
  },
  {
    src: "/images/gallery/rest-rose.jpg",
    caption: "Rest, held — a rose for the mother",
    alt: "A mother resting on white cloth with a red rose beside her",
    description:
      "The heart of the work is rest — held in warm cloth, honored with flowers and quiet, so the mother can be still while her body knits itself back together and her milk comes in.",
  },
];

export default function InHomeGallery() {
  return (
    <section className="mt-24 border-t border-espresso/15 pt-20" data-testid="inhome-gallery">
      <FadeUp>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-sienna">The gallery</p>
        <h2 className="mt-5 max-w-2xl font-serif text-4xl font-light leading-tight text-espresso sm:text-5xl">
          In-home care, as it <span className="italic text-sienna">truly looks</span>
        </h2>
        <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-cocoa" data-testid="gallery-article">
          <p>
            Come close, dear ones, and look. This is our work, gathered in images — each
            one a moment of a mother being tended. The binding of a belly, the lifting of
            a womb, herbs rising in steam, a meal warm from the stove, a companion's steady
            hands, a circle of families learning together.
          </p>
          <p>
            Listen to me: care has always looked like this — hands, warmth, food, and
            presence. As more moments gather here, may you see your own season among them.
            Nothing sterile, nothing hurried. The ways of my grandmother, and her
            grandmother before her — carried into the homes of mothers like you.
          </p>
        </div>
      </FadeUp>

      <div className="mt-14 columns-1 gap-6 sm:columns-2 lg:columns-3" data-testid="gallery-grid">
        {PHOTOS.map((p, i) => (
          <FadeUp key={p.caption} delay={0.05 * (i % 3)} className="mb-6 break-inside-avoid">
            <figure className="group" data-testid={`gallery-item-${i}`}>
              <div className="overflow-hidden rounded-xl border border-espresso/15">
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <figcaption className="mt-4 text-xs font-medium uppercase tracking-[0.2em] text-cocoa/70">
                {p.caption}
              </figcaption>
              {p.description && (
                <p className="mt-3 text-sm leading-relaxed text-cocoa" data-testid={`gallery-description-${i}`}>
                  {p.description}
                </p>
              )}
            </figure>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
